import React from 'react';
import { FormattedMessage } from 'react-intl';

import ChartToolbox from 'components/Charts/ChartToolbox';
import SegmentIcon from 'components/SegmentIcon';
import { fraction, round } from 'shared/constants/math';
import Table from 'components/Table';
import messages from './messages';
import { getFilterSummaryDate } from './formatters';

const ComparisonTable = ({ question, comparedTo, segments, chartSettings, toolbox, precision }) => {
  const showAsPercentage = chartSettings?.displayMode === 'percentage';

  const getSegmentData = segment => segment.values.map(({ name, value, yValue }) => {
    const xValue = showAsPercentage ? fraction(value, segment.uniqueCount) : value;

    return {
      option: name,
      xValue,
      yValue: yValue != null ? round(yValue, precision) : null,
    };
  });

  const formatOption = option => (
    question.translateNames && messages[option]
      ? <FormattedMessage {...messages[option]} />
      : option
  );

  let tableData = [];
  if (segments.length) {
    // Add the first segment and define the data.
    const firstSegmentData = getSegmentData(segments[0]);
    tableData = firstSegmentData.map(d => ({
      key: d.option,
      option: formatOption(d.option),
      xValue0: d.xValue,
      yValue0: d.yValue,
    }));

    for (let index = 1; index < segments.length; index++) {
      const data = getSegmentData(segments[index]);
      data.forEach((d, i) => {
        tableData[i][`xValue${index}`] = d.xValue;
        tableData[i][`yValue${index}`] = d.yValue;
      });
    }
  }

  const columns = [{ dataIndex: 'option', title: <FormattedMessage {...messages.option} /> }];

  segments.filter(s => !s.isBenchmark).forEach((s, i) => {
    let column = columns.find(c => c.title === s.name);
    if (!column) {
      column = { title: s.name, children: [] };
      columns.push(column);
    }

    column.children.push({
      title: (
        <>
          <SegmentIcon segment={s} />
          {getFilterSummaryDate(s)}
        </>
      ),
      children: [{
        title: question.title,
        dataIndex: `xValue${i}`,
        ellipsis: true,
        type: showAsPercentage ? 'percent' : 'number',
        align: 'left',
      }, {
        title: comparedTo.title,
        dataIndex: `yValue${i}`,
        ellipsis: true,
        type: 'number',
        align: 'left',
      }],
    });
  });

  return (
    <>
      <Table
        className="chart__data-view"
        bordered
        size="middle"
        pagination={false}
        style={{ minHeight: 'inherit' }}
        columns={columns}
        dataSource={tableData}
      />
      <ChartToolbox {...toolbox} hasData {...chartSettings} />
    </>
  );
};

export default ComparisonTable;
